// Path: ./src/app/components/FlagLogo/index.tsx
/**
 *
 * FlagLogo
 *
 */
import React, { memo } from "react";
import styled from "styled-components/macro";

interface Props {
  url?: string;
  width?: string;
  height?: string;
  borderRadius?: string;
}

export const FlagLogo = memo((props: Props) => {
  return (
    <FlatLogo
      style={{
        width: props.width ? props.width : "20px",
        height: props.height ? props.height : "20px",
      }}
      src={props.url}
      width={props.width}
      height={props.height}
    ></FlatLogo>
  );
});

const FlatLogo = styled.img`
  border-radius: 34px !important;
  background: white;
`;
